import React from 'react';
import { usePriceContext } from 'contracts/utils/priceContext';
import { ContractSelectGroup, ContractTextInput } from './ContractFields';

const PriceCarry = () => {
  const { carryPercentagePerMonth, carryMonthsIncluded, carryCost } = usePriceContext();

  return (
    <>
      <ContractSelectGroup
        field={carryPercentagePerMonth?.field}
        value={carryPercentagePerMonth?.value}
        onChange={carryPercentagePerMonth?.set}
      />

      <ContractSelectGroup
        field={carryMonthsIncluded?.field}
        value={carryMonthsIncluded?.value}
        onChange={carryMonthsIncluded?.set}
      />

      <ContractTextInput
        field={carryCost?.field}
        value={carryCost?.value || '0.0'}
        type='number'
        step='0.0001'
        min='0.0001'
        onChange={carryCost?.set}
      />
    </>
  );
};

export default PriceCarry;
